import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageCircle, Search } from "lucide-react";
import { motion } from "framer-motion";
import { analytics } from "@/lib/analytics";

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-primary text-primary-foreground relative overflow-hidden">
      {/* Subtle glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-[hsl(var(--green-glow))] opacity-10 blur-3xl translate-x-1/2 -translate-y-1/2" />

      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-semibold mb-6 text-primary-foreground">
            You don't have to figure this out alone
          </h2>
          <p className="text-lg mb-10 text-primary-foreground/80 leading-relaxed">
            Whether you're just starting to explore options or ready to make a
            decision, we're here to help — for free, with no obligation.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button
              size="lg"
              className="bg-card text-foreground hover:bg-card/90 px-8 py-6 text-base shadow-lg"
              onClick={() => { analytics.careAdvisorCTAClick('homepage_cta'); navigate("/consultations"); }}
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              Chat with Care Advisor
            </Button>
            <Button
              size="lg"
              className="bg-transparent border-2 border-primary-foreground/50 text-primary-foreground hover:bg-primary-foreground/10 px-8 py-6 text-base"
              onClick={() => navigate("/nursing-homes")}
            >
              <Search className="mr-2 h-5 w-5" />
              Explore Nursing Homes
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
